import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';

export const SelectedChip = styled(Chip)`
  margin-right: 8px;
`;

export const ContainerGrid = styled(Grid)`
  padding: 8px 16px 16px;
`;

export const ActionButton = styled(Button)`
  margin-left: 8px;
`;

export const HeaderTitle = styled(Typography)`
  font-size: 1rem;
  font-weight: 600;
`;

export const StyledAccordion = styled(Accordion)`
  box-shadow: none;
  border: 1px solid #e0e0e0;
`;

export const StyledSummary = styled(AccordionSummary)`
  background-color: #fafafa;
`;

export const SlotButton = styled(Button)(() => ({
  fontWeight: 500,
  borderRadius: 20,
  padding: '6px 12px',
  textTransform: 'none',
  borderColor: '#d0d7de',
  backgroundColor: '#fff',
  transition: 'all .2s ease',

  '&:hover': {
    backgroundColor: '#f5f7fa',
  },

  '&.selected-slot': {
    color: '#1a73e8',
    borderColor: '#1a73e8',
    backgroundColor: '#c3d4f1',
  },

  '&.selected-slot:hover': {
    backgroundColor: '#dbe7fd',
  },
}));
